/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetMultipleDesadvsRolliIdInput = {
  rolliID: string;
};

export type GetMultipleDesadvsRolliIdQueryVariables = Exact<{
  input: Types.GetMultipleDesadvsRolliIdInput;
}>;

export type GetMultipleDesadvsRolliIdQuery = {
  getMultipleDesadvsRolliID: {
    despatchAdvices: Array<{
      id: string;
      items: Array<{
        handlingUnitSize: number;
        isTotalQuantityEstimate: boolean;
        skus: Array<string>;
        totalQuantity: number;
      }>;
    }>;
  };
};

export const GetMultipleDesadvsRolliIdDocument = gql`
  query getMultipleDesadvsRolliID($input: GetMultipleDesadvsRolliIDInput!) {
    getMultipleDesadvsRolliID(GetMultipleDesadvsRolliIDInput: $input) {
      despatchAdvices {
        id
        items {
          handlingUnitSize
          isTotalQuantityEstimate
          skus
          totalQuantity
        }
      }
    }
  }
`;

/**
 * __useGetMultipleDesadvsRolliIdQuery__
 *
 * To run a query within a React component, call `useGetMultipleDesadvsRolliIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMultipleDesadvsRolliIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMultipleDesadvsRolliIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMultipleDesadvsRolliIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetMultipleDesadvsRolliIdQuery,
    GetMultipleDesadvsRolliIdQueryVariables
  > &
    ({ variables: GetMultipleDesadvsRolliIdQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMultipleDesadvsRolliIdQuery, GetMultipleDesadvsRolliIdQueryVariables>(
    GetMultipleDesadvsRolliIdDocument,
    options,
  );
}
export function useGetMultipleDesadvsRolliIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMultipleDesadvsRolliIdQuery,
    GetMultipleDesadvsRolliIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetMultipleDesadvsRolliIdQuery,
    GetMultipleDesadvsRolliIdQueryVariables
  >(GetMultipleDesadvsRolliIdDocument, options);
}
// @ts-ignore
export function useGetMultipleDesadvsRolliIdSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetMultipleDesadvsRolliIdQuery,
    GetMultipleDesadvsRolliIdQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetMultipleDesadvsRolliIdQuery,
  GetMultipleDesadvsRolliIdQueryVariables
>;
export function useGetMultipleDesadvsRolliIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMultipleDesadvsRolliIdQuery,
        GetMultipleDesadvsRolliIdQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetMultipleDesadvsRolliIdQuery | undefined,
  GetMultipleDesadvsRolliIdQueryVariables
>;
export function useGetMultipleDesadvsRolliIdSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMultipleDesadvsRolliIdQuery,
        GetMultipleDesadvsRolliIdQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetMultipleDesadvsRolliIdQuery,
    GetMultipleDesadvsRolliIdQueryVariables
  >(GetMultipleDesadvsRolliIdDocument, options);
}
export type GetMultipleDesadvsRolliIdQueryHookResult = ReturnType<
  typeof useGetMultipleDesadvsRolliIdQuery
>;
export type GetMultipleDesadvsRolliIdLazyQueryHookResult = ReturnType<
  typeof useGetMultipleDesadvsRolliIdLazyQuery
>;
export type GetMultipleDesadvsRolliIdSuspenseQueryHookResult = ReturnType<
  typeof useGetMultipleDesadvsRolliIdSuspenseQuery
>;
export type GetMultipleDesadvsRolliIdQueryResult = Apollo.QueryResult<
  GetMultipleDesadvsRolliIdQuery,
  GetMultipleDesadvsRolliIdQueryVariables
>;
